import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';

import LoadingComponent from '../../../../../assets/LoadingComponent';
import { chunkArray } from 'utils/General';
import TagsCardEdit from './TagsCardEdit';
import config from '../config';


const styles = {
  wrapper: {
    height: '100%',
    display: 'flex',
    padding: '15px 15px 15px 25px',
  },
  firstLayerColumn: {
    borderLeft: 'none !important',
  },
  layerColumn: {
    display: 'flex',
    padding: '0 10px',
    borderLeft: '2px dashed rgb(139, 139, 145)',
  },
  column: {
    width: '250px',
    padding: '5px',
    margin: '0 5px',
    overflowY: 'auto',
    border: '1px solid #e9e9e9',
  },
};

class TagsEdit extends React.PureComponent {
  static get getLayersLimitCount() {
    return 6;
  }

  static getNodesLayers(nodes, edges, rootNodeId) {
    const rootNode = nodes.find(node => node.id === rootNodeId);
    const nodesQueue = [rootNode];
    const nodesIndexes = {};
    nodesIndexes[rootNode.id] = {
      layerIndex: 0,
      verticalIndex: 0,
    };

    const nodesMap = {};
    nodes.forEach((node) => {
      nodesMap[node.id] = node;
    });

    const layerMaxVerticalIndex = {
      0: 0,
    };

    while (nodesQueue.length !== 0) {
      const node = nodesQueue.shift();
      const nodeLayerIndex = nodesIndexes[node.id].layerIndex;
      const nodeEdges = node.buttons.map(button => edges.find(edge => edge.buttonId === button.id)).filter(edge => edge !== undefined);
      nodeEdges.forEach((edge) => {
        if (edge.questionId && nodesIndexes[edge.questionId] === undefined && nodesMap[edge.questionId] !== undefined) {
          let edgeNodeVerticalIndex = 0;
          if (layerMaxVerticalIndex[nodeLayerIndex] === undefined) {
            layerMaxVerticalIndex[nodeLayerIndex] = edgeNodeVerticalIndex;
          } else {
            edgeNodeVerticalIndex = layerMaxVerticalIndex[nodeLayerIndex] + 1;
          }
          layerMaxVerticalIndex[nodeLayerIndex] = edgeNodeVerticalIndex;

          nodesIndexes[edge.questionId] = {
            layerIndex: nodeLayerIndex + 1,
            verticalIndex: edgeNodeVerticalIndex,
          };
          nodesQueue.push(nodesMap[edge.questionId]);
        }
      });
    }

    return nodesIndexes;
  }

  static splitNodesByLayers(nodes, nodesIndexes) {
    let layersNumber = 1;
    const nodesIndexData = Object.values(nodesIndexes);
    for (const nodeIndex of nodesIndexData) {
      if (nodeIndex.layerIndex + 1 > layersNumber) {
        layersNumber = nodeIndex.layerIndex + 1;
      }
    }

    const nodesByLayers = [];
    for (let i = 0; i < layersNumber; ++i) {
      nodesByLayers.push([]);
    }

    nodes.forEach((node) => {
      const nodeIndexInfo = nodesIndexes[node.id];

      if (nodeIndexInfo === undefined) {
        return;
      }

      nodesByLayers[nodeIndexInfo.layerIndex].push(node);
    });

    nodesByLayers.forEach(layerNodes => layerNodes.sort((a, b) => nodesIndexes[a.id].verticalIndex - nodesIndexes[b.id].verticalIndex));

    return nodesByLayers;
  }

  render() {
    const {
      nodes, edges, locale, editTags, rootNodeId, user
    } = this.props;
    if (nodes.length === 0) {
      return (
        <LoadingComponent />
      );
    }

    const nodesIndexes = TagsEdit.getNodesLayers(nodes, edges, rootNodeId);
    const nodesByLayers = TagsEdit.splitNodesByLayers(nodes, nodesIndexes);

    return (
      <div style={styles.wrapper} className="tags-view">
        {nodesByLayers.map((layerNodes, layerIndex) => {
          const limitedInColumnNodes = chunkArray(layerNodes, TagsEdit.getLayersLimitCount);
          return (
            <div key={layerIndex} style={layerIndex !== 0 ? [styles.layerColumn] : [styles.layerColumn, styles.firstLayerColumn]}>
              {limitedInColumnNodes.map((columnNodes, columnIndex) => (
                <div key={columnIndex} style={styles.column}>
                  {columnNodes.map(node => <TagsCardEdit key={`${locale}-${node.id}`} node={node} editTags={editTags} user={user} />)}
                </div>
              ))}
            </div>
          );
        })}
      </div>
    );
  }
}

TagsEdit.propTypes = {
  nodes: PropTypes.array.isRequired,
  edges: PropTypes.array.isRequired,
  rootNodeId: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  editTags: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default Radium(TagsEdit);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/components/TagsEdit.jsx